// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Scrollable from "../../../../../../../library/components/Scrollable.bs.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Button$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormDateInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormDateInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as WalletTransactionStatus from "../../../../app/wallet/entity/WalletTransactionStatus.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as WalletTransactionListView from "./WalletTransactionListView.bs.js";

var allOption = {
  key: "ALL",
  value: "ALL",
  text: "ALL"
};

var validators_transactionStatus = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var transactionStatus = param.transactionStatus;
      if (transactionStatus === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please Select a status"
              };
      }
      var allStatus = transactionStatus.value;
      if (allStatus === "ALL") {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: WalletTransactionStatus.fromString(allStatus)
              };
      }
    })
};

var validators = {
  transactionStatus: validators_transactionStatus,
  tillDate: undefined
};

function initialFieldsStatuses(_input) {
  return {
          transactionStatus: /* Pristine */0,
          tillDate: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            transactionStatus: /* Pristine */0,
            tillDate: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.transactionStatus;
  var match_0 = match ? match._0 : Curry._1(validators.transactionStatus.validate, input);
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.tillDate
  };
  var transactionStatusResult = match_0;
  var transactionStatusResult$1;
  if (transactionStatusResult.TAG === /* Ok */0) {
    var tillDateResult = match_0$1;
    if (tillDateResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                tillDate: tillDateResult._0,
                transactionStatus: transactionStatusResult._0
              },
              fieldsStatuses: {
                transactionStatus: /* Dirty */{
                  _0: transactionStatusResult,
                  _1: /* Shown */0
                },
                tillDate: /* Dirty */{
                  _0: tillDateResult,
                  _1: /* Hidden */1
                }
              },
              collectionsStatuses: undefined
            };
    }
    transactionStatusResult$1 = transactionStatusResult;
  } else {
    transactionStatusResult$1 = transactionStatusResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            transactionStatus: /* Dirty */{
              _0: transactionStatusResult$1,
              _1: /* Shown */0
            },
            tillDate: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurTransactionStatusField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.transactionStatus, validators_transactionStatus, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  transactionStatus: status,
                                  tillDate: init.tillDate
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTillDateField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.tillDate, state.fieldsStatuses.tillDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  transactionStatus: init.transactionStatus,
                                  tillDate: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateTransactionStatusField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.transactionStatus, state.submissionStatus, validators_transactionStatus, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            transactionStatus: status,
                                            tillDate: init.tillDate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTillDateField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.tillDate, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            transactionStatus: init.transactionStatus,
                                            tillDate: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                transactionStatus: /* Pristine */0,
                                tillDate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                transactionStatus: /* Pristine */0,
                                tillDate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateTransactionStatus: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTransactionStatusField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTillDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTillDateField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurTransactionStatus: (function (param) {
              return Curry._1(dispatch, /* BlurTransactionStatusField */0);
            }),
          blurTillDate: (function (param) {
              return Curry._1(dispatch, /* BlurTillDateField */1);
            }),
          transactionStatusResult: Formality.exposeFieldResult(state.fieldsStatuses.transactionStatus),
          tillDateResult: Formality.exposeFieldResult(state.fieldsStatuses.tillDate),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.transactionStatus || match.tillDate) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var WalletTransactionFilterForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getDefaultTransactionStatus(txnStatus, options) {
  if (txnStatus !== undefined) {
    return List.find((function (a) {
                  return a.value === WalletTransactionStatus.toString(txnStatus);
                }), options);
  } else {
    return List.nth(options, 0);
  }
}

function getTransactionStatusItems(param) {
  var statusDropdownItems = List.map((function (txnStatus) {
          var statusString = WalletTransactionStatus.toString(txnStatus);
          return {
                  key: statusString.toLowerCase(),
                  value: statusString,
                  text: statusString
                };
        }), WalletTransactionStatus.getWalletStatusList(undefined));
  return {
          hd: allOption,
          tl: statusDropdownItems
        };
}

function WalletListViewSections$Sections$LeftContainer$FiltersSection(Props) {
  var filters = Props.filters;
  var onFiltersSubmit = Props.onFiltersSubmit;
  var transactionStatusOptions = getTransactionStatusItems(undefined);
  var form = useForm({
        tillDate: filters.tillDate,
        transactionStatus: getDefaultTransactionStatus(filters.transactionStatus, transactionStatusOptions)
      }, (function (output, submissionCbs) {
          Curry._1(onFiltersSubmit, {
                tillDate: output.tillDate,
                transactionStatus: output.transactionStatus
              });
          return Curry._1(submissionCbs.notifyOnSuccess, undefined);
        }));
  return React.createElement("div", {
              className: "filter-section u-bottom-border"
            }, React.createElement("div", {
                  className: "filter-field-section"
                }, React.createElement(FormDateInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("Until Date", (function (param) {
                              
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.tillDateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      date_props: {
                        value: Caml_option.some(form.input.tillDate),
                        minDate: undefined,
                        maxDate: undefined,
                        onChange: (function (date) {
                            return Curry._2(form.updateTillDate, (function (input, value) {
                                          return {
                                                  tillDate: value,
                                                  transactionStatus: input.transactionStatus
                                                };
                                        }), date);
                          }),
                        format: "dd/MM/YYYY",
                        autoOk: false,
                        views: [
                          "year",
                          "month",
                          "date"
                        ]
                      }
                    })), React.createElement("div", {
                  className: "filter-field-section"
                }, React.createElement(FormSelectInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("Status", (function ($$event) {
                              return Curry._2(form.updateTransactionStatus, (function (input, value) {
                                            return {
                                                    tillDate: input.tillDate,
                                                    transactionStatus: value
                                                  };
                                          }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), transactionStatusOptions));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.transactionStatusResult, undefined, "status-input-dropdown", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        value: form.input.transactionStatus,
                        items: transactionStatusOptions,
                        isNoneRequired: true
                      }
                    })), React.createElement(Button$Catalyst.make, {
                  text: "SUBMIT",
                  cb: (function (_event) {
                      return Curry._1(form.submit, undefined);
                    }),
                  className: "btn-primary--green filter-field-section"
                }));
}

var FiltersSection = {
  allOption: allOption,
  WalletTransactionFilterForm: WalletTransactionFilterForm,
  getDefaultTransactionStatus: getDefaultTransactionStatus,
  getTransactionStatusItems: getTransactionStatusItems,
  make: WalletListViewSections$Sections$LeftContainer$FiltersSection
};

function WalletListViewSections$Sections$LeftContainer(Props) {
  var filters = Props.filters;
  var onFiltersSubmit = Props.onFiltersSubmit;
  return React.createElement(Column$Catalyst.make, {
              children: React.createElement(WalletListViewSections$Sections$LeftContainer$FiltersSection, {
                    filters: filters,
                    onFiltersSubmit: onFiltersSubmit
                  }),
              className: "left-container u-right-border"
            });
}

var LeftContainer = {
  FiltersSection: FiltersSection,
  make: WalletListViewSections$Sections$LeftContainer
};

function WalletListViewSections$Sections$RightContainer(Props) {
  var state = Props.state;
  var onScrollEndCallback = Props.onScrollEndCallback;
  var report = state.report;
  var tmp;
  if (typeof report === "number") {
    tmp = React.createElement("div", undefined, "Fetching Wallet Report");
  } else {
    switch (report.TAG | 0) {
      case /* Loading */0 :
          var report$1 = report._0;
          tmp = report$1 !== undefined ? React.createElement(Scrollable.make, {
                  height: "99%",
                  onScrollEndCallback: (function (param) {
                      
                    }),
                  children: React.createElement(WalletTransactionListView.make, {
                        transactions: report$1.transactions
                      })
                }) : React.createElement("div", undefined, "Fetching Wallet Report");
          break;
      case /* Live */1 :
          tmp = React.createElement(Scrollable.make, {
                height: "99%",
                onScrollEndCallback: onScrollEndCallback,
                children: React.createElement(WalletTransactionListView.make, {
                      transactions: report._0.transactions
                    })
              });
          break;
      case /* Error */2 :
          tmp = React.createElement("div", undefined, "Error Fetching Wallet Report. Try Submitting again");
          break;
      
    }
  }
  return React.createElement("div", {
              className: "right-container"
            }, tmp);
}

var RightContainer = {
  make: WalletListViewSections$Sections$RightContainer
};

var Sections = {
  LeftContainer: LeftContainer,
  RightContainer: RightContainer
};

export {
  Sections ,
  
}
/* react Not a pure module */
